import { store } from 'quasar/wrappers'
import { createStore } from 'vuex'
import user from './stores/userstore.js'
import options from './stores/options.js'
import queue from './stores/queue.js'
import interval from './stores/interval.js'
import { createErrorsModule } from './stores/errors';

export default store(function () {
  const Store = createStore({
    modules: {
      user,
      options,
      queue,
      interval,
      errors: createErrorsModule('/errors'),
      pharmacyErrors: createErrorsModule('/pharmacies/me/errors'),
    },
    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: process.env.DEBUGGING
  })
  return Store
});
